import colors from './colors';

/**
 * Generates CSS variable definitions from the color theme
 * Use this to inject CSS variables into your application
 */
export const generateCSSVariables = () => {
  const cssVars = {
    // Primary Colors
    '--color-primary-main': colors.primary.main,
    '--color-primary-light': colors.primary.light,
    '--color-primary-dark': colors.primary.dark,
    '--color-primary-contrast': colors.primary.contrast,

    // Secondary Colors
    '--color-secondary-main': colors.secondary.main,
    '--color-secondary-light': colors.secondary.light,
    '--color-secondary-dark': colors.secondary.dark,

    // Blue
    '--color-blue-main': colors.blue.main,
    '--color-blue-light': colors.blue.light,
    '--color-blue-dark': colors.blue.dark,
    '--color-blue-lighter': colors.blue.lighter,
    '--color-blue-background': colors.blue.background,
    '--color-blue-border': colors.blue.border,

    // Green
    '--color-green-main': colors.green.main,
    '--color-green-light': colors.green.light,
    '--color-green-dark': colors.green.dark,
    '--color-green-lighter': colors.green.lighter,
    '--color-green-border': colors.green.border,
    '--color-green-success': colors.green.success,

    // Red
    '--color-red-main': colors.red.main,
    '--color-red-light': colors.red.light,
    '--color-red-dark': colors.red.dark,

    // Orange
    '--color-orange-main': colors.orange.main,
    '--color-orange-warning': colors.orange.warning,
    '--color-orange-alert': colors.orange.alert, // Tailwind Orange 400

    // Grey
    '--color-grey-50': colors.grey[50],
    '--color-grey-100': colors.grey[100],
    '--color-grey-200': colors.grey[200],
    '--color-grey-300': colors.grey[300],
    '--color-grey-400': colors.grey[400],
    '--color-grey-500': colors.grey[500],
    '--color-grey-600': colors.grey[600],
    '--color-grey-700': colors.grey[700],
    '--color-grey-800': colors.grey[800],
    '--color-grey-900': colors.grey[900],

    // Background
    '--color-bg-default': colors.background.default,
    '--color-bg-paper': colors.background.paper,
    '--color-bg-secondary': colors.background.secondary,
    '--color-bg-disabled': colors.background.disabled,
    '--color-bg-overlay': colors.background.overlay,

    // Text
    '--color-text-primary': colors.text.primary,
    '--color-text-secondary': colors.text.secondary,
    '--color-text-disabled': colors.text.disabled,
    '--color-text-white': colors.text.white,

    // Border
    '--color-border-main': colors.border.main,
    '--color-border-light': colors.border.light,
    '--color-border-medium': colors.border.medium,
    '--color-border-input': colors.border.input,
    '--color-border-divider': colors.border.divider,

    // Button
    '--color-button-primary': colors.button.primary,
    '--color-button-primary-hover': colors.button.primaryHover,
    '--color-button-secondary': colors.button.secondary,
    '--color-button-error': colors.button.error,

    // Status
    '--color-status-pending': colors.status.pending,
    '--color-status-started': colors.status.started,
    '--color-status-success': colors.status.success,
    '--color-status-failure': colors.status.failure,

    // Sidebar
    '--color-sidebar-bg': colors.sidebar.background,
    '--color-sidebar-border': colors.sidebar.border,
    '--color-sidebar-text': colors.sidebar.text,

    // Header
    '--color-header-bg': colors.header.background,
    '--color-header-border': colors.header.border,
    '--color-header-text': colors.header.text,

    // Footer
    '--color-footer-bg': colors.footer.background,
    '--color-footer-border': colors.footer.border,
    '--color-footer-text': colors.footer.text,

    // Table
    '--color-table-header-bg': colors.table.headerBackground,
    '--color-table-row-bg': colors.table.rowBackground,
    '--color-table-category-header': colors.table.categoryHeader,
  };

  return cssVars;
};

/**
 * Injects CSS variables into the document root
 * Call this in your main app entry point (e.g., index.js)
 */
export const applyCSSVariables = () => {
  const cssVars = generateCSSVariables();
  const root = document.documentElement;

  Object.entries(cssVars).forEach(([key, value]) => {
    root.style.setProperty(key, value);
  });
};

/**
 * Returns CSS variables as a style object
 * Useful for applying to a specific element
 */
export const getCSSVariablesAsStyle = () => {
  return generateCSSVariables();
};

export default {
  applyCSSVariables,
  getCSSVariablesAsStyle,
  generateCSSVariables,
};
